import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";
import { fadeUp, fadeRight } from "@/lib/motion";
import { ABOUT_FEATURES, IMAGES } from "@/data/content";

const AboutSection = () => {
  return (
    <section className="relative py-24 sm:py-32 bg-white" id="about" data-testid="about-section">
      <div className="max-w-[1320px] mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
          {/* Image with clipped frame */}
          <Reveal variants={fadeRight} className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl shadow-slate-900/10">
              <img
                src={IMAGES.about}
                alt="Engineering consultation and acoustic testing"
                className="w-full h-[520px] object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 ring-1 ring-inset ring-slate-900/10 rounded-3xl" />
            </div>
            <div className="absolute -bottom-8 -left-4 sm:-left-8 bg-[#0F172A] text-white rounded-2xl p-6 sm:p-7 shadow-xl max-w-[240px]">
              <div className="font-display font-bold text-4xl text-white">100+</div>
              <div className="text-sm text-slate-300 mt-1">Certificates delivered across India</div>
            </div>
            <div className="absolute -top-6 -right-4 hidden sm:block w-24 h-24 rounded-2xl border-2 border-[#1E40AF]/20 bg-blue-50/50" />
          </Reveal>

          {/* Text */}
          <div>
            <SectionHeading
              overline="About AutoDrive"
              title="About AutoDrive Tech Solutions"
              description="AutoDrive Tech Solutions is a specialized consulting firm based in India, providing end-to-end certification and regulatory consulting services exclusively for the automotive industry. Our mission is to bridge the gap between automotive innovators and India's complex homologation and testing landscape."
            />
            <Reveal custom={3}>
              <p className="mt-5 text-slate-600 leading-relaxed">
                We act as a vital link, guiding manufacturers through the intricate process of obtaining
                necessary approvals and ensuring compliance with Indian automotive regulations. We help our
                clients achieve speed-to-market while mitigating regulatory risks and maintaining the highest
                standards of quality and safety.
              </p>
            </Reveal>

            <div className="mt-10 grid sm:grid-cols-2 gap-4">
              {ABOUT_FEATURES.map((f, i) => (
                <Reveal key={f.title} variants={fadeUp} custom={i} className="group rounded-2xl border border-slate-200 bg-white p-5 hover:border-[#1E40AF]/30 hover:shadow-lg hover:shadow-slate-900/5 transition-[border-color,box-shadow] duration-300">
                  <span className="inline-flex items-center justify-center w-11 h-11 rounded-xl bg-blue-50 text-[#1E40AF] group-hover:bg-[#1E40AF] group-hover:text-white transition-colors">
                    <f.icon className="w-5 h-5" strokeWidth={1.75} />
                  </span>
                  <h3 className="mt-4 font-display font-semibold text-[#0F172A] text-base">{f.title}</h3>
                  <p className="mt-1.5 text-sm text-slate-500 leading-relaxed">{f.text}</p>
                </Reveal>
              ))}
            </div>

            <Reveal custom={2}>
              <Link
                to="/about"
                data-testid="about-read-more"
                className="mt-10 inline-flex items-center gap-2 text-[#1E40AF] font-semibold hover:gap-3 transition-all group"
              >
                Read More
                <ArrowRight className="w-4 h-4" />
              </Link>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
